import { Edit3, Trash2 } from "lucide-react";
import EmptyState from "../components/EmptyState";
import { Truck } from "lucide-react";

function feeLabel(zone) {
  if (zone.requires_manual_quote) return "Manual quote";
  if (zone.is_free) return "Free";
  return `$${Number(zone.flat_fee || 0).toFixed(2)}`;
}

export default function DeliveryZoneList({ zones, onAdd, onEdit, onDelete }) {
  if (!zones.length) return <EmptyState icon={Truck} title="No delivery zones yet" description="Add a delivery zone to define where and how SugaLumps delivers." actionLabel="Add Delivery Zone" onAction={onAdd} />;
  return (
    <section className="delivery-zone-section">
      <div className="delivery-section-heading"><h2>Delivery zones</h2><button type="button" className="btn" onClick={onAdd}>Add Delivery Zone</button></div>
      <div className="delivery-zone-grid">
        {zones.map((zone) => (
          <article key={zone.id} className="delivery-zone-card">
            <div><span className={`delivery-zone-badge delivery-zone-badge--${zone.zone_type}`}>{feeLabel(zone)}</span><h3>{zone.name}</h3><p>{zone.description || "No description"}</p></div>
            <dl><div><dt>Range</dt><dd>{zone.minute_range_label}</dd></div><div><dt>Status</dt><dd>{zone.is_active ? "Active" : "Inactive"}</dd></div></dl>
            <footer><button type="button" className="btn btn--secondary" onClick={() => onEdit(zone)}><Edit3 size={16} /> Edit</button><button type="button" className="btn admin-danger-button" onClick={() => onDelete(zone)}><Trash2 size={16} /> Delete</button></footer>
          </article>
        ))}
      </div>
    </section>
  );
}
